import type { DecorationSprite } from '../types';

// v2 §D1: sprite name → emoji glyph. The sprite *name* is the public API
// (custom theme picker, AI proxy schema); the glyph is the v2 default
// rendering. When/if we switch to SVG sprites later, only this map and
// the CSS sprite styles change — the spec contract is unaffected.
const SPRITE_GLYPH: Record<DecorationSprite, string> = {
  cloud: '☁️',
  star: '⭐',
  bubble: '🫧',
  leaf: '🍃',
  sparkle: '✨',
  snow: '❄️',
  fish: '🐠',
  butterfly: '🦋',
};

export function spriteGlyph(name: DecorationSprite): string {
  return SPRITE_GLYPH[name];
}
